/* eslint-disable no-unused-vars */
import jsFileDownload from 'js-file-download'
import apiDownload from '@/services/api/modules/download'
import { ASYNC_EXPORT_COLUMN_TYPE_ENUM } from '@/services/enums'
import HcBizDownloadCenterGuidModal from '@/components/HcBizDownloadCenterGuidModal/index.vue'
import HcBizDownloadCenterBrief from '@/components/HcBizDownloadCenterBrief/index.vue'

import app, { getVueH } from '@/main'

/**
 * 下载一个blob文件到本地
 * @param {} blob
 * @param {*} filename
 */
export function downloadBlob(blob, filename = '文件') {
  jsFileDownload(blob, filename)
}

/**
 * 异步下载列表 简要的弹窗
 */
function showDownloadCenterBriefModal(exportCode) {
  const h = getVueH()
  let dialog = null

  const handleComfirm = () => {
    dialog.close()
  }

  const handleCancel = () => {
    dialog.close()
  }

  dialog = app.$dialog({
    title: '导出记录',
    width: 'big',
    isMaxHeight: true,
    component: () => {
      return (
        <HcBizDownloadCenterBrief
          vOn:comfirm={handleComfirm}
          vOn:cancel={handleCancel}
          exportCode={exportCode}
        ></HcBizDownloadCenterBrief>
      )
    },
  })
}

export async function createAsyncExportTask(
  exportCode,
  exportColumnType = ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv.value,
  queryData = {},
  data = {},
  options = {}
) {
  const { type } = data
  // 下载类型：1-创建下载任务，2-查看导出记录
  if (type === 2) {
    return showDownloadCenterBriefModal(exportCode)
  }
  try {
    const res = await apiDownload.fetchCreateAsyncDownloadTask(
      exportCode,
      exportColumnType,
      queryData,
      data,
      options,
    )

    const { code } = res || {}
    if (code !== 200) {
      // 出现异常情况，直接弹出导出记录modal
      setTimeout(() => {
        showDownloadCenterBriefModal(exportCode)
      }, 1000)
      return
    }

    const h = getVueH()

    let dialog = null
    const handleComfirm = () => {
      if (dialog) {
        dialog.close()
        showDownloadCenterBriefModal(exportCode)
      }
    }

    const handleCancel = () => {
      if (dialog) {
        dialog.close()
      }
    }
    dialog = app.$dialog({
      title: '提示',
      width: 'small',
      component: () => {
        return (
          <HcBizDownloadCenterGuidModal
            vOn:comfirm={handleComfirm}
            vOn:cancel={handleCancel}
          ></HcBizDownloadCenterGuidModal>
        )
      },
    })
  } catch (err) {
    app.$message.error('操作失败，请稍后再试')
  }
}
